'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  PrismProductCopyInProgressWarning
// -----------------------------------------------------------
const PrismProductCopyInProgressWarning = ({className}) => {
  return (
    <div className={ className } role="alert">
      <strong>Warning:&nbsp;</strong>
        this item is still being prepared.  Please check back later.
    </div>
  );
};

PrismProductCopyInProgressWarning.displayName = 'PrismProductCopyInProgressWarning'

export default PrismProductCopyInProgressWarning;
